const SQE_LABS_RESTRICTED_PATHS = new Set([
  "/performance",
  "/reimbursementrequest",
  "/createreimbursementrequest",
  "/approvereimbursements",
  "/bulkreimbursement",
  "/reimbursement-history",
  "/downloadreimbursement",
  "/projectlist",
  "/myproject",
  "/shadowresources",
  "/csatrating",
  "/configuration",
  "/tracking",
  "/reports",
]);

const SQE_EMPLOYEE_TYPES = new Set(["SQE", "SQELABS"]);
const SQE_RESTRICTED_MENU_NAMES = new Set([
  "announcements",
  "new announcement",
  "events",
  "employee offboarding",
  "initiate offboarding",
  "offboarding review",
  "offboarding it",
  "offboarding admin",
  "offboarding payroll",
  "offboarding hr",
  "offboarding rm",
]);
const SQE_RESTRICTED_MENU_PATHS = new Set([
  "/create-announcement",
  "/view-announcement",
  "/initiateresignation",
  "/offboardl1",
  "/offboardlit",
  "/offboardladmin",
  "/offboardlpayroll",
  "/offboardlhr",
  "/offboardlrm",
]);

type NavigationLabelOverride = {
  employeeTypes: ReadonlySet<string>;
  matches: (label: string) => boolean;
  replacement: string;
};

const NAVIGATION_LABEL_OVERRIDES: readonly NavigationLabelOverride[] = [
  {
    employeeTypes: SQE_EMPLOYEE_TYPES,
    matches: (label) => /caelius'?\s+policies/i.test(label),
    replacement: "SQE Policies",
  },
  {
    employeeTypes: SQE_EMPLOYEE_TYPES,
    matches: (label) => label.trim().toLowerCase() === "caelius connect",
    replacement: "SQE Connect",
  },
];

function normalizeEmployeeType(value: unknown): string {
  return String(value ?? "")
    .replace(/[^a-zA-Z0-9]/g, "")
    .toUpperCase();
}

export function formatNavigationLabel(
  label: string | undefined,
  employeeTypes: unknown | readonly unknown[],
): string | undefined {
  if (!label) return label;

  const canonicalLabel = /caelius'?\s+policies/i.test(label.trim())
    ? "Caelius Policies"
    : label;
  const normalizedTypes = (Array.isArray(employeeTypes) ? employeeTypes : [employeeTypes])
    .map(normalizeEmployeeType);
  const override = NAVIGATION_LABEL_OVERRIDES.find(
    (item) =>
      normalizedTypes.some((type) => item.employeeTypes.has(type)) &&
      item.matches(canonicalLabel),
  );

  return override?.replacement ?? canonicalLabel;
}

export function isSQELabsEmployeeType(value: unknown): boolean {
  return normalizeEmployeeType(value) === "SQELABS";
}

export function isSQEEmployeeType(value: unknown): boolean {
  return SQE_EMPLOYEE_TYPES.has(normalizeEmployeeType(value));
}

export function isRestrictedForSQELabsMenu(name: string): boolean {
  const normalized = name.trim().toLowerCase();
  return (
    normalized.includes("assessment") ||
    normalized.includes("reimbursement") ||
    normalized === "project teamflow" ||
      normalized === "my projects"
  );
}

export function isRestrictedForSQEEmployeeMenu(
  name: string,
): boolean {
  const normalized = name.trim().replace(/\s+/g, " ").toLowerCase();
  return SQE_RESTRICTED_MENU_NAMES.has(normalized);
}

export function isRestrictedForSQELabsPath(path: string | undefined): boolean {
  return path
    ? SQE_LABS_RESTRICTED_PATHS.has(path.trim().toLowerCase())
    : false;
}

export function isRestrictedForSQEEmployeePath(path: string | undefined): boolean {
  if (!path) return false;

  const normalized = path.trim().toLowerCase().replace(/^\/dashboard/, "") || "/";
  return Array.from(SQE_RESTRICTED_MENU_PATHS).some(
    (restrictedPath) =>
      normalized === restrictedPath || normalized.startsWith(`${restrictedPath}/`),
  );
}
